import { observer } from 'mobx-react';
import React from 'react';

import { Paginated } from '../../../../adl-gen/common';
import { DbKey } from '../../../../adl-gen/common/db';
import { AppClient, WorkRole } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { WorkRoleListEntry } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { WorkRoleReferenceData } from '../../../../adl-gen/totalinteraction/futurefit/requests';
import { Loader, MaybeLoading } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { PageLayoutFn } from '../../../../ui/common/page-layout/page-layout';
import { ListView } from '../../common/list/list-view';
import { WorkRoleListView } from '../../components/lists/workrole-list/workrole-list-view';

interface WorkRoleScreenProps {
  pageLayout: PageLayoutFn;
  navigateTo(route: Route): void;

  roles: MaybeLoading<Paginated<WorkRoleListEntry>>;
  roleData: MaybeLoading<WorkRoleReferenceData>;

  appClientId?: DbKey<AppClient>;
}

@observer
export class WorkRoleScreen extends React.Component<WorkRoleScreenProps> {
  onSelectRole = async (roleId: DbKey<WorkRole>) => {
    this.props.navigateTo({
      route: 'admin',
      page: 'role',
      appClientId: this.props.appClientId,
      id: roleId
    });
  };

  onCreateRole = () => {
    this.props.navigateTo({
      route: 'admin',
      page: 'role',
      appClientId: this.props.appClientId,
      view: 'new'
    });
  };

  renderRoleList = observer((roles: Paginated<WorkRoleListEntry>) => {
    const { roleData } = this.props;
    if (roleData.kind === 'value') {
      return (
        <ListView
          list={roles}
          fields={WorkRoleListView}
          refData={roleData.value}
          onSelect={this.onSelectRole}
          onCreate={this.onCreateRole}
        />
      );
    } else {
      return null;
    }
  });

  RolesLoader = () => <Loader state={this.props.roles} LoadedComponent={this.renderRoleList} />;

  render() {
    /// Title is required to ensure subnav gets rendered
    return (
      <this.props.pageLayout title={'Administration - Roles'}>
        <this.RolesLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/workrole-screen/workrole-screen.tsx